import EmptyLayout from '@/views/layouts/EmptyLayout.vue';

export default [
    {
        path: 'sitemap',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            // Strony
            {
                path: 'pages',
                name: 'cms-pages',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/pages/PagesList.vue'),
                children: [
                    {
                        path: 'add/:folderId',
                        props: true,
                        name: 'cms-pages-add',
                        meta: { auth: true },
                        component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/pages/PageForm.vue')
                    },
                    {
                        path: ':id',
                        props: true,
                        name: 'cms-pages-edit',
                        meta: { auth: true },
                        component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/pages/PageForm.vue')
                    }
                ]
            },
            // Aranżacje
            {
                path: 'layouts',
                name: 'cms-layouts',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/layouts/MainView.vue')
            },
            // Witryny
            {
                path: 'websites',
                name: 'cms-websites',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/websites/WebsitesList.vue')
            },
            {
                path: 'websites/add',
                name: 'cms-websites-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/websites/WebsiteForm.vue')
            },
            {
                path: 'websites/:id',
                name: 'cms-websites-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/websites/WebsiteForm.vue')
            }
        ]
    },
    {
        // Moduły
        path: 'modules',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            // Strony opisowe
            // {
            //     path: 'content',
            //     name: 'cms-articles',
            //     meta: { auth: true },
            //     component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/articles/ContentList.vue')
            // },
            // {
            //     path: 'content/add',
            //     name: 'cms-articles-add',
            //     meta: { auth: true },
            //     component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/articles/ContentForm.vue')
            // },
            // {
            //     path: 'content/:id',
            //     name: 'cms-articles-edit',
            //     meta: { auth: true },
            //     component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/articles/ContentForm.vue')
            // },
            // Aktualności
            {
                path: 'informations',
                name: 'cms-informations',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/informations/InformationsList.vue')
            },
            {
                path: 'informations/add',
                name: 'cms-informations-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/informations/InformationForm.vue')
            },
            {
                path: 'informations/:id',
                name: 'cms-informations-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "cms" */ '@/views/modules/cms/informations/InformationForm.vue')
            }
        ]
    }
];
